import { RouteType } from '@/Routes';
import { lazy } from 'react';

const MyInfoIndex = lazy(() => import('@/pages/myinfo'));
const MyInfoEditPhoneNumber = lazy(
  () => import('@/pages/myinfo/edit_phone_number')
);
const MyInfoEditEmailRequest = lazy(
  () => import('@/pages/myinfo/edit_email/request')
);
const MyInfoEditEmailConfirm = lazy(
  () => import('@/pages/myinfo/edit_email/confirm')
);

const ServerMyInfo: RouteType[] = [
  { path: '/myinfo', component: MyInfoIndex, title: 'ユーザー情報' },
  {
    path: '/myinfo/edit_phone_number',
    component: MyInfoEditPhoneNumber,
    title: '電話番号を編集',
  },
  {
    path: '/myinfo/edit_email/request',
    component: MyInfoEditEmailRequest,
    title: 'メールアドレスを編集',
  },
  {
    path: '/myinfo/edit_email/confirm',
    component: MyInfoEditEmailConfirm,
    title: 'メールアドレスを編集',
  },
];

export default ServerMyInfo;
